import { render, staticRenderFns } from "./ViewAnalyticsBase.vue?vue&type=template&id=c4e8b3b6&scoped=true&"
import script from "./ViewAnalyticsBase.vue?vue&type=script&lang=js&"
export * from "./ViewAnalyticsBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e8b3b6",
  null
  
)

export default component.exports